// Shared branded-QR compositing for the web app.
//
// Single source of truth for how a QR is placed inside the SecuDoc frame, so every web
// surface (Create Document Metadata, My Documents modal) stays identical. The layout mirrors
// the server-side generateCompositeQr Cloud Function and qr-frame-mark-empty.svg:
// a 300×356 card with a 240×240 QR slot inset 30 px.
//
// NOTE: the Cloud Function can't import this (it runs in Node with ImageMagick, not a browser
// canvas), so it necessarily keeps its own copy of these constants — keep them in sync by hand.
import QRCode from "qrcode";
import qrFrameUrl from "@/assets/brand/qr-frame-mark-empty.svg";

export const FRAME_W = 300;
export const FRAME_H = 356;
export const QR_SLOT = 30;
export const QR_W = 240;

// Render a QR encoding `payload` composited inside the branded frame.
// Pass an existing `canvas` (e.g. a template ref) to draw into it; omit it to composite
// off-screen. Resolves with the canvas's PNG data URL (usable as an <img> src).
export function renderFramedQr(payload, canvas) {
	return new Promise((resolve, reject) => {
		// QR_W fills the frame slot exactly; margin 0 keeps the frame's white slot as the quiet zone.
		QRCode.toDataURL(payload, { width: QR_W, margin: 0 }, (error, qrDataUrl) => {
			if (error) { reject(error); return; }

			const target = canvas || document.createElement("canvas");
			target.width = FRAME_W;
			target.height = FRAME_H;
			const ctx = target.getContext("2d");

			// Composite the branded frame first, then drop the QR into the slot.
			const frameImg = new Image();
			frameImg.onload = () => {
				ctx.clearRect(0, 0, FRAME_W, FRAME_H);
				ctx.drawImage(frameImg, 0, 0, FRAME_W, FRAME_H);
				const qrImg = new Image();
				qrImg.onload = () => {
					ctx.drawImage(qrImg, QR_SLOT, QR_SLOT, QR_W, QR_W);
					resolve(target.toDataURL("image/png"));
				};
				qrImg.onerror = reject;
				qrImg.src = qrDataUrl;
			};
			frameImg.onerror = reject;
			frameImg.src = qrFrameUrl;
		});
	});
}
